<script lang="ts">
  import { currentLanguage } from "../../Services/i18n"

  function onChange(event: Event): void {
    const { value } = event.target as HTMLSelectElement
    $currentLanguage = value
  }

</script>

<div class="lang-select">
  <img class="flag" src="/images/flags/{$currentLanguage}.svg" alt="">
  <select value={$currentLanguage} on:change={onChange}>
    <option value="es">Español</option>
    <option value="en">English</option>
    <option value='fr'>Français</option>
    <option value='de'>Deutsch</option>
    <option value='it'>Italiano</option>
    <option value='pt'>Português</option>
  </select>
</div>

<style lang="scss">

  .lang-select {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .flag {
    width: 24px;
    height: 24px;
    box-sizing: border-box;
  }

  select {
    border: none;
    outline: none;
    padding: 0.5rem;
    box-sizing: border-box;
    display: block;
    width: 100%;
    border-radius: 0.25rem;
  }

</style>
